import React from 'react'
import createUploadForm, { createModelSchema } from '../ContentUploadForm'
import { titles } from '../../setup/stubs'
import IconCar from '../../vectors/IconCar'
import {
  UploadFormHeader,
  UploadFormHeaderIcon,
  UploadFormSubHeading,
  UploadFormHeading,
  StyledTick,
  Label,
  Message,
  Input,
  Widget
} from '../ContentUploadForm/components'
import * as yup from 'yup'
import { Flex, Box } from 'rebass'

const mutation = `mutation createBodyshop($data: BodyshopSubmissionInput, $files: [Upload]) {
  createBodyshopSubmission(uploadRequest: $data, files: $files) {
    email
    createdDate
  }
}`

const schema = createModelSchema({
  make: yup.string().default('').required('Please enter the vehicle make'),
  model: yup.string().default('').required('Please enter the vehicle model'),
  registration: yup
    .string()
    .default('')
    .required('Please enter the vehicle registration'),
  damageDetails: yup.string().default('')
})

const textStrings = {
  trackingTitle: 'Bodyshop',
  fileUploadTitle: 'Upload Damage',
  fileUploadSubtitle:
    'To get a quote, please upload photos or videos of the damage to the vehicle',
  submitErrorText:
    'Your bodyshop form didn’t upload properly, please try again.',
  submitButtonText: 'Submit Request',
  submitLoadingSpinner: 'Sending Request',
  submitSuccessText:
    'Thank you for contacting us, one of our Citygate team members will be in touch shortly.'
}

const Fields = (props) => (
  <>
    <UploadFormHeader>
      <UploadFormHeaderIcon muted={!!props.formComplete}>
        {props.formComplete ? <StyledTick /> : <IconCar />}
      </UploadFormHeaderIcon>
      <Box>
        <UploadFormSubHeading muted={props.formComplete}>
          Second Step
        </UploadFormSubHeading>
        <UploadFormHeading muted={props.formComplete}>
          Vehicle details
        </UploadFormHeading>
      </Box>
    </UploadFormHeader>
    <Flex flexWrap="wrap" width={'100%'} py={[10]}>
      <Box width={[12 / 12, null, '28%']} mr={[0, null, '8%']} mb={20}>
        <Label>Make</Label>
        <Widget>
          <Input
            placeholder="Vehicle Make"
            name="make"
            aria-label="You are required to enter the make"
            onChange={props.handleChangeEvent}
          />
          <Message for="make" />
        </Widget>
      </Box>
      <Box width={[12 / 12, null, '28%']} mr={[0, null, '8%']} mb={20}>
        <Label>Model</Label>
        <Widget>
          <Input
            placeholder="Vehicle Model"
            name="model"
            aria-label="You are required to enter the model"
            onChange={props.handleChangeEvent}
          />
          <Message for="model" />
        </Widget>
      </Box>
      <Box width={[12 / 12, null, '28%']} mb={20}>
        <Label>Registration</Label>
        <Widget>
          <Input
            placeholder="Vehicle Registration"
            name="registration"
            aria-label="You are required to enter the registration"
            onChange={props.handleChangeEvent}
          />
          <Message for="registration" />
        </Widget>
      </Box>
      <Box width={[12 / 12, null, '100%']} mb={20}>
        <Label>Damage</Label>
        <Widget>
          <Input
            placeholder="Vehicle Damage"
            name="damageDetails"
            onChange={props.handleChangeEvent}
          />
          <Message for="damageDetails" />
        </Widget>
      </Box>
    </Flex>
  </>
)

const ContentUploadForm = createUploadForm(mutation, schema, Fields)

const ContentBodyshopForm = (props) => (
  <ContentUploadForm
    {...props}
    {...textStrings}
    titles={titles}
    fieldCount={9}
    f24name="bodyshop-form"
  />
)

export default ContentBodyshopForm
